const resources = {
    featuredOffers: 'Featured Offers'
};

export default function getResource(label) {
    return resources[label];
}
